import { CalendarDots } from "@phosphor-icons/react";

import { TemplateEditor } from "common/components/Templates";
import TemplatePreviewPlaceholder from "common/components/Templates/TemplatePreviewPlaceholder";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { formatDate } from "common/helpers/utils";
import type { CreatedTemplate, Template } from "common/types";

import type { JSX } from "react";
import type { UseFormReturn } from "react-hook-form";

export default function DesktopTemplate({
  previewComponent,
  form,
  //when this is true, the name input field is displayed
  isCreatingNew = false,
  isDisabled = false,
}: {
  previewComponent: JSX.Element;
  form: UseFormReturn<Template | CreatedTemplate>;
  isCreatingNew?: boolean;
  isDisabled?: boolean;
}) {
  const { accounts_count: accountsCount } = useSelectedWorkspaceContext();
  const hasAccounts = accountsCount > 0;

  return (
    <div className="flex flex-col overflow-hidden">
      {isCreatingNew && (
        <div className="flex justify-between items-center mb-4">
          <FormField
            size="sm"
            label="Template name"
            htmlFor="templateName"
            className="w-1/2"
            error={form.formState.errors.name?.message}
          >
            <Input
              variant="sm"
              {...form.register("name")}
              hasError={!!form.formState.errors.name?.message}
            />
          </FormField>
          <div className="flex items-center gap-x-0.5 pl-1.5 text-black-500">
            <CalendarDots className="size-4" />
            <span className="text-xs-medium">
              Created: {formatDate(Date.now())}
            </span>
          </div>
        </div>
      )}
      <div className="flex gap-x-2 overflow-hidden">
        <TemplateEditor form={form} isEditable={!isDisabled} />
        {hasAccounts ? previewComponent : <TemplatePreviewPlaceholder />}
      </div>
    </div>
  );
}
